import React from 'react';
import { View, Image, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { SVG_COMPONENTS as ADMIN_SVG_COMPONENTS } from '@/assets/admin';
import { RESIDENTS_MOBILE_COLORS } from '@/constants/residents/mobile/color';

export type AttachmentItem = {
  id: string;
  name: string;
  uri: string;
  type: string;
};

type Props = {
  attachments: AttachmentItem[];
  onRemove: (id: string) => void;
  showDocChip?: boolean;
};

export const AttachmentPreview: React.FC<Props> = ({ attachments, onRemove, showDocChip = true }) => {
  if (!attachments || attachments.length === 0) return null;
  return (
    <View style={styles.fileUploadPreview}>
      <View style={styles.attachmentsContainer}>
        {attachments.map((f) => {
          const isImage = (f.type || '').startsWith('image/');
          if (isImage) {
            return (
              <View key={f.id} style={styles.imageThumbWrapper}>
                <Image source={{ uri: f.uri }} style={styles.imageThumb} />
                <TouchableOpacity style={styles.imageThumbClose} onPress={() => onRemove(f.id)}>
                  <Text style={styles.imageThumbCloseText}>×</Text>
                </TouchableOpacity>
              </View>
            );
          }
          if (!showDocChip) return null;
          return (
            <View key={f.id} style={styles.docChip}>
              <ADMIN_SVG_COMPONENTS.PAPERCLIP width={14} height={14} color={RESIDENTS_MOBILE_COLORS.TEXT_SECONDARY} />
              <Text style={styles.docName} numberOfLines={1}>{f.name}</Text>
              <TouchableOpacity style={styles.docRemove} onPress={() => onRemove(f.id)}>
                <ADMIN_SVG_COMPONENTS.X_CIRCLE width={18} height={18} color={RESIDENTS_MOBILE_COLORS.TEXT_TERTIARY} />
              </TouchableOpacity>
            </View>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  fileUploadPreview: { paddingHorizontal: 12, paddingTop: 8 },
  attachmentsContainer: { flexDirection: 'row', flexWrap: 'wrap' },
  imageThumbWrapper: { width: 80, height: 80, borderRadius: 8, overflow: 'hidden', marginRight: 8, marginBottom: 8, backgroundColor: '#F3F4F6' },
  imageThumb: { width: '100%', height: '100%' },
  imageThumbClose: { position: 'absolute', top: 4, right: 4, width: 20, height: 20, borderRadius: 10, backgroundColor: 'rgba(0,0,0,0.6)', alignItems: 'center', justifyContent: 'center' },
  imageThumbCloseText: { color: '#FFFFFF', fontSize: 12, fontWeight: '700' },
  docChip: { flexDirection: 'row', alignItems: 'center', borderWidth: 1, borderColor: RESIDENTS_MOBILE_COLORS.BORDER_PRIMARY, backgroundColor: '#FFFFFF', paddingHorizontal: 10, paddingVertical: 8, borderRadius: 16, marginRight: 8, marginBottom: 8 },
  docName: { color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY, maxWidth: 160 },
  docRemove: { marginLeft: 8 },
});

export default AttachmentPreview;


